// You need something like this to access a prop of css, or the entering
// state transition will happen too fast and css will process it in the same
// tick, and the transition will not be seen.

// https://github.com/reactjs/react-transition-group/issues/223#issuecomment-334748429
export const onEnterHandler = (node: HTMLElement) => node.offsetHeight;
